import { HTMLAttributes } from 'react';
import { AddressValidationResult } from 'typescript/types/api/address_validation';
import { isValidationPartiallyVerified } from 'typescript/utilities/address_validation';
import ValidationFailure from 'typescript/apps/checkout_v3/components/address_validation/validation_failure';
import ValidationPartiallyVerified from 'typescript/apps/checkout_v3/components/address_validation/validation_partially_verified';

interface AddressValidationProps extends HTMLAttributes<HTMLDivElement> {
  addressValidationResult?: AddressValidationResult | null;
  onOriginalClick?: () => void;
  onCorrectedClick?: () => void;
}

const AddressValidation = ({
  className,
  addressValidationResult,
  onCorrectedClick,
  onOriginalClick,
}: AddressValidationProps) => {
  if (!addressValidationResult) {
    return null;
  }

  if (isValidationPartiallyVerified(addressValidationResult)) {
    return (
      <ValidationPartiallyVerified
        className={className}
        correctedAddress={addressValidationResult.corrected_address}
        onOriginalClick={onOriginalClick}
        onCorrectedClick={onCorrectedClick}
      />
    );
  }

  return (
    <ValidationFailure
      className={className}
      originalAddress={addressValidationResult.original_address}
      onOriginalClick={onOriginalClick}
    />
  );
};

export default AddressValidation;
